module.exports = __webpack_public_path__ + "static/media/CHOPM_MENU-normal.afc40b48.png";